// extracted by mini-css-extract-plugin
export default {"relacion":"TablaPersonaParientes_relacion__wHz06","pariente":"TablaPersonaParientes_pariente__l6VyB"};